export default __webpack_public_path__ + "static/media/Ostali 4.de69bb66.jpg";